module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/navigation/up-right-679c101ba91be3a95b0a57d62debf05b.svg";